import React from "react";
import ActionSource from "./actions";
import ACTION_CONSTANTS from "./action_constants";

const STORAGE_KEY = "primary_data";

const initialState = {
	storageLoaded: false,
	locale: "en",
	cartItems: [],
};

let localState = initialState;

try {
	localState = JSON.parse(localStorage.getItem(STORAGE_KEY));
} catch (err) {
	// console.log("Some Error Occured: ", err);
}

const setData = (data) => {
	if (data.storageLoaded) {
		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
			// console.log("SET DATA: ", data);
		} catch (e) {
			// saving error
		}
	}
};

const reducer = (state, action) => {
	switch (action.type) {
		case ACTION_CONSTANTS.CLEAR_CACHE:
			return {
				...initialState,
				storageLoaded: true,
			};
		case ACTION_CONSTANTS.CHANGE_LOCALE:
			return {
				...state,
				locale: action.payload,
			};
		case ACTION_CONSTANTS.CHANGE_THEME:
			return {
				...state,
				darkMode: action.payload,
			};
		case ACTION_CONSTANTS.STORAGE_LOADED:
			return {
				...(localState || initialState),
				storageLoaded: action.payload,
			};
		case ACTION_CONSTANTS.UPDATE_CART:
			return {
				...state,
				cartItems: action.payload,
			};
		default:
			return state;
	}
};

const AppContext = React.createContext();

const Provider = ({ children }) => {
	const [state, dispatch] = React.useReducer(reducer, localState || initialState);
	// console.log("STATE: ", state);
	const actionList = new ActionSource({ dispatch, states: state });
	const value = {
		storageLoaded: state.storageLoaded,
		locale: state.locale,
		cartItems: state.cartItems,
		...actionList,
	};

	if (state.storageLoaded === false) {
		try {
			localState = JSON.parse(localStorage.getItem(STORAGE_KEY));
			// console.log("GET DATA WHEN STORAGE NOT LOADED: ", localState);
			dispatch({ type: ACTION_CONSTANTS.STORAGE_LOADED, payload: true });
		} catch (e) {
			// error reading value
		}
	}

	React.useEffect(() => {
		setData(state);
	}, [state]);

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export { Provider, AppContext };
